module.exports = __webpack_public_path__ + "images/logos/logo_wide_alternate@2x.14a16cd0f8a6ca54b19fb7e4f32540aa.png";